export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8190.247d0628.jpg";